/* Student "Mes parcours" page — dummy placeholder (to wire to real parcours */
/* backend later). */

import { HeaderContent, HEADER_TITLE_CLASS } from '../../components/shell/app-header';
import { Badge } from '../../components/ui/badge';
import { PARCOURS_EN_COURS, PARCOURS_RECOMMANDES } from '../../data/student-dummy';

export default function Parcours() {
  return (
    <>
      <HeaderContent width="md" showBurger backTo="/mini-apps" backLabel="Mini-apps">
        <div className="min-w-0">
          <h1 className={HEADER_TITLE_CLASS}>Mes parcours</h1>
          <p className="m-0 mt-0.5 text-[13px] sm:text-[13.5px] leading-snug text-muted-foreground">
            Tes parcours d'apprentissage guidés par Naïa. <em>(données de démonstration)</em>
          </p>
        </div>
      </HeaderContent>
      <main className="max-w-[880px] mx-auto px-5 pb-16 pt-4">

        <Section title="EN COURS">
          {PARCOURS_EN_COURS.map((p) => (
            <div key={p.id} className="flex items-center gap-3 px-4 py-[14px] border-b border-border">
              <span aria-hidden className="w-10 h-10 shrink-0 rounded-[12px] grid place-items-center font-black text-[13px]" style={{ background: `${p.color}1a`, color: p.color }}>
                {p.tag}
              </span>
              <div className="flex-1 min-w-0">
                <div className="font-extrabold text-[15px]">{p.title}</div>
                <div className="text-xs text-muted-foreground font-semibold">{p.subject}</div>
                <div className="h-2 rounded-full bg-naia-info-bg overflow-hidden mt-2">
                  <div className="h-full" style={{ width: `${p.progress}%`, background: p.color }} />
                </div>
              </div>
              <span className="font-extrabold shrink-0" style={{ color: p.color }}>{p.progress}%</span>
            </div>
          ))}
        </Section>

        <Section title="À DÉCOUVRIR">
          {PARCOURS_RECOMMANDES.map((p) => (
            <div key={p.id} className="flex items-center gap-3 px-4 py-[14px] border-b border-border">
              <span aria-hidden className="w-10 h-10 shrink-0 rounded-[12px] grid place-items-center font-black text-[13px]" style={{ background: `${p.color}1a`, color: p.color }}>
                {p.tag}
              </span>
              <div className="flex-1 min-w-0">
                <div className="font-extrabold text-[15px]">{p.title}</div>
                <div className="text-xs text-muted-foreground font-semibold">{p.subject}</div>
              </div>
              <Badge variant="outline" className="text-muted-foreground shrink-0">Bientôt disponible</Badge>
            </div>
          ))}
        </Section>
      </main>
    </>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <>
      <div className="text-[11px] font-black tracking-[1.5px] text-muted-foreground mt-6 mb-[10px]">{title}</div>
      <div className="bg-card border border-border rounded-card overflow-hidden shadow-card">
        {children}
      </div>
    </>
  );
}
